import React from 'react';
import { Input } from "antd";

import { FormItem } from 'utils';


const MainFieldSet = (props) => {
  const { serviceGroup, ...otherProps } = props;
  return (
    <div className="form-block">
      <FormItem {...otherProps} name="name" label="Название" required={true}>
        <Input size="large"/>
      </FormItem>

      <FormItem {...otherProps} name="slug" label="Путь" required={true}>
        <Input size="large"/>
      </FormItem>

      <FormItem {...otherProps} name="sort" label="Сортировка" required={true}>
        <Input size="large"/>
      </FormItem>
    </div>
  );
};

export default MainFieldSet;
